import { render, staticRenderFns } from "./yearStatistic.vue?vue&type=template&id=8d856ca2&scoped=true"
import script from "./yearStatistic.vue?vue&type=script&lang=js"
export * from "./yearStatistic.vue?vue&type=script&lang=js"
import style0 from "./yearStatistic.vue?vue&type=style&index=0&id=8d856ca2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d856ca2",
  null
  
)

export default component.exports